"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _SttContainer = _interopRequireDefault(require("../SttLayout/SttContainer"));
var _core = require("@material-ui/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    "tituloHeader": {
      color: '#0A6FB8',
      padding: theme.spacing(0.3),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderBottomStyle: 'solid'
    }
  };
});
var SttTituloData = function SttTituloData(_ref) {
  var modulo = _ref.modulo;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "h2",
    className: classes.tituloHeader
  }, /*#__PURE__*/_react["default"].createElement("strong", null, modulo)));
};
var _default = SttTituloData;
exports["default"] = _default;